import { Component, h, State, Event, EventEmitter } from '@stencil/core';
import store from '../../../helpers/store';

import { FlowStatus } from '../../../models/FlowStatus';
import { BaseComponent } from '../../base-component';
import { FlowSteps } from '../../../models/FlowSteps';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import { ApiCall } from '../../../helpers/ApiCall';
// import { IdCaptureValues } from '../../../helpers/textValues';
// import { delay } from '../../../utils/utils';
// import { IDPose } from '../../../libs/IDML5Detector/IDPose';

// @ts-ignore
import loaderImg from '../../../assets/loader.svg';
import logoOntrace from '../../../assets/logo-ontrace.svg';

@Component({
  tag: 'how-to-info',
  styleUrl: 'how-to-info.css',
  shadow: false,
})
export class HowToInfo {
  private translations: TranslationValues;
  private currentStep: FlowSteps;

  // @State() private showVideo: boolean;
  @State() topTitle: string;
  @State() subTitle: string;
  @State() imagePath: string;
  @State() buttonText: string;
  @State() buttonEnabled: boolean;
  // @State() private demoVideo: HTMLVideoElement;
  @State() private image: HTMLImageElement;
  @State() private imageLoaded: boolean;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  constructor() {}

  async componentDidLoad() {
    if (store.flowStatus == FlowStatus.IDFRONTHOWTO) {
      this.imageLoaded = false;
      this.currentStep = FlowSteps.CiFrontHowTo;
      this.topTitle = this.translations.HowToValues.IdFaceTitle;
      this.subTitle = this.translations.HowToValues.IdFaceSubTitle;
      this.buttonText = this.translations.HowToValues.IdButton;
      this.loadImage('https://ekyc.blob.core.windows.net/$web/howto_id.gif');
    } else if (store.flowStatus == FlowStatus.IDBACKHOWTO) {
      this.currentStep = FlowSteps.CiBackHowTo;
      this.topTitle = this.translations.HowToValues.IdBackTitle;
      this.subTitle = this.translations.HowToValues.IdBackSubTitle;
      this.buttonText = this.translations.HowToValues.IdButton;
      this.loadImage('https://ekyc.blob.core.windows.net/$web/howto_id_back.gif');
      // this.demoVideo.src = IdCaptureValues.IDPoseDemoMapping[IDPose.Rotate];
      // this.demoVideo.play();
      // await delay(this.translations.GlobalValues.VideoLenght);
      // await this.buttonClick();
    } else if (store.flowStatus == FlowStatus.IDTILTHOWTO) {
      this.imageLoaded = false;
      this.currentStep = FlowSteps.CiTiltHowTo;
      this.topTitle = this.translations.HowToValues.TiltTitle;
      this.subTitle = this.translations.HowToValues.TiltSubTitle;
      this.buttonText = this.translations.HowToValues.TiltButton;
      this.loadImage('https://ekyc.blob.core.windows.net/$web/howto_id_tilt.gif');
    } else if (store.flowStatus == FlowStatus.LIVENESSHOWTO) {
      this.imageLoaded = false;
      this.currentStep = FlowSteps.SelfieHowTo;
      this.topTitle = this.translations.HowToValues.SelfieTitle;
      this.subTitle = this.translations.HowToValues.SelfieSubTitle;
      this.buttonText = this.translations.HowToValues.SelfieButton;
      this.loadImage('https://ekyc.blob.core.windows.net/$web/howto_selfie.gif');
    }

    await BaseComponent.initialize(this.currentStep);
  }

  async disconnectedCallback() {
    await BaseComponent.finalize(this.currentStep);
  }

  async buttonClick() {
    this.buttonEnabled = false;
    store.flowStatus = await ApiCall.instance.GetNextFlowState();
  }

  async componentWillLoad() {
    // this.showVideo = store.flowStatus == FlowStatus.IDBACKHOWTO;
    this.translations = await Translations.getValues();
    this.buttonEnabled = true;
  }

  loadImage = src =>
    new Promise((resolve, reject) => {
      this.image.onload = () => {
        this.imageLoaded = true;
        resolve(this.image);
      };
      this.image.onerror = reject;
      this.image.src = src;
    });

  render() {
    let howTo = (
      // this.showVideo == true ? (
      //   <div class="container bg-black">
      //     <div class="container-video">
      //       <div>
      //         <video id="howTo" class="video-demo" playsinline ref={el => (this.demoVideo = el)}>
      //           <source type="video/mp4"></source>
      //         </video>
      //       </div>
      //       <div class="capture-title">
      //         <h1 class="color-white text-center">{this.topTitle}</h1>
      //         <p class="main-text font-size-18 text-right mb-0">{this.translations.GlobalValues.FooterText}</p>
      //       </div>
      //     </div>
      //   </div>
      // ) :
      <div class="container flex center">
        <div hidden={this.imageLoaded == false} class="px-2 w-100">
          <h1 class="text-center px-1 mb-1" innerHTML={this.topTitle}></h1>
          <div class="mb-1">
            <img class="w-100" ref={el => (this.image = el)} />
          </div>

          <div class="button flex mb-1">
            {!this.buttonEnabled ? (
              <div class="img-loader rounded img-loader-button">
                <img class="loading-image loading-image-button" src={loaderImg}></img>
              </div>
            ) : null}
            <button class="main-button" type="button" disabled={!this.buttonEnabled} onClick={() => this.buttonClick()}>
              {this.buttonText}
            </button>
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );

    return howTo;
  }
}
